import { useEffect, useState, useRef } from "react";
import styles from "./image-preview.module.scss";
import { Image, Text } from "components/commons";
import { extractDirectoryWithFile } from "components/commons/select-file/select-file";
import { ImageSharp } from "@material-ui/icons";
import clsx from "clsx";

const ImagePreview = ({ value, onClose }) => {
  const [url, setUrl] = useState(value);
  const [isZoomed, setIsZoomed] = useState(false);
  const [origin, setOrigin] = useState("center center");
  const imageRef = useRef(null);

  useEffect(() => {
    setUrl(value);
    setIsZoomed(false);
    setOrigin("center center");
  }, [value]);

  const handleImageClick = (e) => {
    e.stopPropagation();

    const rect = imageRef.current.getBoundingClientRect();
    const clickX = e.clientX - rect.left;
    const clickY = e.clientY - rect.top;
    const percentX = (clickX / rect.width) * 100;
    const percentY = (clickY / rect.height) * 100;

    setOrigin(`${percentX}% ${percentY}%`);
    setIsZoomed((prev) => !prev);
  };

  return (
    url && (
      <div className={styles.preview} onClick={() => onClose?.()}>
        <div className={styles.info}>
          <ImageSharp fontSize="medium" style={{ color: "white" }} />
          <Text strong color="white">
            {extractDirectoryWithFile(url)}
          </Text>
        </div>
        <Image
          ref={imageRef}
          className={clsx(styles.image, isZoomed && styles.zoomed)}
          style={{
            transformOrigin: origin,
          }}
          onClick={handleImageClick}
          src={url}
          alt={url}
        />
      </div>
    )
  );
};

export default ImagePreview;
